














export default {
  name: 'ProgrammePlanCard',
  props: {
    plan: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: 'lwi',
    },
  },
  computed: {},
};
